import React from "react";
import { Menu, Icon, Button, Layout } from "antd";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import classes from "./PageLayout.css";
import { withRouter } from "react-router";
import { withParams } from "../../utils/url";
import {
  getReadUnassignedConsentRecordsPermission,
  getAdminSettingsPermission,
  getAuditLogReadPermission,
  getCustomFormsReadPermission,
  getDocumentPharmacyBinderPermission,
  getDocumentPublicReadPermission,
  getDocumentReadPermission,
  getDocumentStudyRegulatoryBinderPermission,
  getDocumentTrainingReadPermission,
  getDrugAccessPermissionInEnrollment,
  getDrugManagementStatus,
  getValidationRequiredStatus,
  getDrugReadPermission,
  getFinanceCustomerReadPermission,
  getFinanceEventReadPermission,
  getFinanceInvoiceGeneratedEventReadPermission,
  getFinanceInvoiceReadPermission,
  getFinanceReadPermission,
  getFollowUp30dReadPermission,
  getFollowUp7dReadPermission,
  getLanguages,
  getMyProfileReadPermission,
  getNewsletterReadPermission,
  getConsentAccessPermission,
  getPatientProfileCreatePermission,
  getPatientProfileReadPermission,
  getPermissions,
  getProjectConfigurationStatus,
  getRandomizationAccessPermission,
  getReportsReadPermission,
  getRoleReadPermission,
  getSAEReadPermission,
  getApiIbmReadPermission,
  getApiEcoaReadPermission,
  getApiImednetReadPermission,
  getApiDatafaxReadPermission,
  getSimulationReadPermission,
  getSiteReadPermission,
  getSubjectIssuesReadPermission,
  getSubjectProfileUploadReadPermission,
  getUnblindingRequestApprovePermission,
  getUnblindingRequestCreatePermission,
  getUnblindingRequestReadPermission,
  getUserInfo,
  getUserReadPermission,
  getUserToken,
  getValidateRandomizationAccessPermission,
  getDelegationLogAdminReadPermission,
  getMyProfileViewIdPermission,
  getDelegationLogSignPermission,
  getUserInfoRoles,
  getDocumentPerSiteReadPermission,
  getDocumentPerSitePrivateReadPermission,
  getDocumentGeneralReadPermission,
  getDocumentGeneralPrivateReadPermission,
  getDocumentValidationReadPermission,
  getViewDocumentDashboardPermission,
  getReadRedcapApiConfigPermission,
  getReadDFDiscoverApiConfigPermission,
} from "../../reducers/user/selectors";
import { getTheme } from "../../reducers/theme/selectors";
import { connect } from "react-redux";
import classNames from "classnames";
import get from "lodash/get";
import AdminHeader from "../../components/AdminHeader/AdminHeader";
import Footer from "../../components/Footer/Footer";
const routes = require("../../routes.json");

const { SubMenu } = Menu;

const menuRandomization = (props) => (
  <SubMenu
    key="randomization"
    title={
      <span>
        <Icon type="form" />
        <span>{props.i18n.t("Randomization")}</span>
      </span>
    }
  >
    {props.randomizationAccessPermission && (
      <Menu.Item key="randomizationAccessPermission">
        <Link to={routes.admin.randomize} rel="noopener noreferrer">
          {props.randomizationAccessPermission && props.consentAccessPermission ? props.i18n.t("Start randomization/Consent") : props.i18n.t("Start Randomization")}
        </Link>
      </Menu.Item>
    )}
    {props.consentAccessPermission && !props.randomizationAccessPermission && (
      <Menu.Item key="obtainConsent">
        <Link to={withParams(routes.admin.consentRandomization, { obtainConsent: 'true' })} rel="noopener noreferrer">
          {props.i18n.t("Obtain Consent")}
        </Link>
      </Menu.Item>
    )}
    {props.consentAccessPermission && (
      <Menu.Item key="consent">
        <Link to={routes.admin.consent} rel="noopener noreferrer">
          {props.i18n.t("Update Consent")}
        </Link>
      </Menu.Item>
    )}
    {props.readUnassignedConsentRecordsPermission && (
      <Menu.Item key="readUnassignedConsentRecordsPermission">
        <Link to={routes.admin.unassignedConsentRecords}>
          {props.i18n.t("Unassigned Consent Records")}
        </Link>
      </Menu.Item>
    )}
    {props.patientProfileReadPermission && (
      <Menu.Item key="patientProfileReadPermission">
        <Link to={routes.admin.enrolments}>
          {props.i18n.t("Subject Randomization List")}
        </Link>
      </Menu.Item>
    )}
    {(props.apiIbmReadPermission ||
      props.apiImednetReadPermission ||
      props.apiEcoaReadPermission ||
      props.getReadDFDiscoverApiConfigPermission ||
      props.getReadRedcapApiConfigPermission ||
      props.apiDatafaxReadPermission) && (
      <Menu.Item>
        <Link to={routes.admin.profileList}>
          {props.i18n.t("NamespaceAdminHeader:API Management")}
        </Link>
      </Menu.Item>
    )}
    {props.validateRandomizationAccessPermission &&
      props.validationRequiredStatus && (
        <Menu.Item key="validateRandomizationAccessPermission">
          <Link
            to={withParams(routes.admin.enrollmentListAdmin, {
              listName: "validation",
            })}
            rel="noopener noreferrer"
          >
            {props.i18n.t("NamespaceAdminHeader:Subject Validation List")}
          </Link>
        </Menu.Item>
      )}
    {props.unblindingRequestReadPermission && (
      <Menu.Item key="unblindingRequestReadPermission">
        <Link to={routes.admin.unblindings}>
          {props.i18n.t("NamespaceAdminHeader:Unblinding Request List")}
        </Link>
      </Menu.Item>
    )}
    {props.SAEReadPermission && (
      <Menu.Item key="SAEReadPermission">
        <Link to={routes.admin.saeReporting}>
          {props.i18n.t("NamespaceAdminHeader:+ Record SAE")}
        </Link>
      </Menu.Item>
    )}
  </SubMenu>
);

const menuPatients = (props) => (
  <SubMenu
    key="patients"
    title={
      <span>
        <Icon type="usergroup-add" />
        <span>{props.i18n.t("Patients")}</span>
      </span>
    }
  >
    {props.SAEReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.saeReporting}>
          {props.i18n.t("NamespaceAdminHeader:+ Record SAE")}
        </Link>
      </Menu.Item>
    )}
    {props.subjectIssuesReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.qualityControl}>
          {props.i18n.t("NamespaceAdminHeader:Quality Control")}
        </Link>
      </Menu.Item>
    )}
    {props.patientProfileReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.enrolments}>
          {props.i18n.t("NamespaceAdminHeader:View all enrolments")}
        </Link>
      </Menu.Item>
    )}
  </SubMenu>
);

const menuDrugManagement = (props) => (
  <SubMenu
    key="drugManagement"
    title={
      <span>
        <Icon type="experiment" />
        <span>{props.i18n.t("Drug Management")}</span>
      </span>
    }
  >
    <Menu.Item>
      <Link to={routes.admin.drugs} className="ant-dropdown-link">
        {props.i18n.t("Drug management")}
      </Link>
    </Menu.Item>
    <Menu.Item>
      <Link to={routes.admin.inventory} rel="noopener noreferrer">
        {props.i18n.t("NamespaceAdminHeader:Inventory")}
      </Link>
    </Menu.Item>
  </SubMenu>
);

const menuFinance = (props) =>
  props.financeReadPermission && (
    <SubMenu
      key="finance"
      title={
        <span>
          <Icon type="bank" />
          <span>{props.i18n.t("Finance")}</span>
        </span>
      }
    >
      {props.financeCustomerReadPermission && (
        <Menu.Item>
          <Link to={routes.admin.financeCustomers} rel="noopener noreferrer">
            {props.i18n.t("Customers")}
          </Link>
        </Menu.Item>
      )}
      {props.financeEventReadPermission && (
        <Menu.Item>
          <Link to={routes.admin.financePrices} rel="noopener noreferrer">
            {props.i18n.t("Prices")}
          </Link>
        </Menu.Item>
      )}
      {props.financeInvoiceReadPermission && (
        <Menu.Item>
          <Link to={routes.admin.financeInvoices} rel="noopener noreferrer">
            {props.i18n.t("Invoices")}
          </Link>
        </Menu.Item>
      )}
      {props.financeInvoiceGeneratedEventReadPermission && (
        <Menu.Item>
          <Link
            to={routes.admin.financeGeneratedEvents}
            rel="noopener noreferrer"
          >
            {props.i18n.t("NamespaceAdminHeader:Generated events")}
          </Link>
        </Menu.Item>
      )}
    </SubMenu>
  );

const menuTrialResources = (props) => (
  <SubMenu
    key="trialResources"
    title={
      <span>
        <Icon type="bars" />
        <span>{props.i18n.t("NamespaceAdminHeader:Trial resources")}</span>
      </span>
    }
  >
    {props.documentTrainingReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.documentsTraining} rel="noopener noreferrer">
          {props.i18n.t("Training Documents")}
        </Link>
      </Menu.Item>
    )}
    {props.documentPublicReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.documentsPublic} rel="noopener noreferrer">
          {props.i18n.t("Public Documents")}
        </Link>
      </Menu.Item>
    )}
    {props.documentStudyRegulatoryBinderPermission && (
      <Menu.Item>
        <Link
          to={routes.admin.documentsStudyRegulatoryBinder}
          rel="noopener noreferrer"
        >
          {props.i18n.t("Study Regulatory Binder")}
        </Link>
      </Menu.Item>
    )}
    {props.documentPharmacyBinderPermission && props.isDrugManagementActive && (
      <Menu.Item>
        <Link
          to={routes.admin.documentsPharmacyBinder}
          rel="noopener noreferrer"
        >
          {props.i18n.t("Pharmacy Binder")}
        </Link>
      </Menu.Item>
    )}
    {props.documentGeneralReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.documentsGeneral} rel="noopener noreferrer">
          {props.i18n.t("General documents")}
        </Link>
      </Menu.Item>
    )}
    {props.documentGeneralPrivateReadPermission && (
      <Menu.Item>
        <Link
          to={routes.admin.documentsGeneralPrivate}
          rel="noopener noreferrer"
        >
          {props.i18n.t("General private documents")}
        </Link>
      </Menu.Item>
    )}
    {props.documentValidationReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.documentsValidation} rel="noopener noreferrer">
          {props.i18n.t("Validation documents")}
        </Link>
      </Menu.Item>
    )}
    {props.documentPerSiteReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.documentsPerSite} rel="noopener noreferrer">
          {props.i18n.t("Site documents")}
        </Link>
      </Menu.Item>
    )}
    {props.documentPerSitePrivateReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.documentsPerSitePrivate} rel="noopener noreferrer">
          {props.i18n.t("Site Private documents")}
        </Link>
      </Menu.Item>
    )}
    {props.auditLogReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.auditLogs} rel="noopener noreferrer">
          {props.i18n.t("Audit logs")}
        </Link>
      </Menu.Item>
    )}
    {props.simulationReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.simulation} rel="noopener noreferrer">
          {props.i18n.t("NamespaceAdminHeader:Simulation")}
        </Link>
      </Menu.Item>
    )}
    {props.delegationLogAdminReadPermission && (
      <Menu.Item>
        <Link to={routes.admin.delegationLogs} rel="noopener noreferrer">
          {props.i18n.t("NamespaceAdminHeader:Delegation Logs")}
        </Link>
      </Menu.Item>
    )}
    {props.delegationLogSignPermission && (
      <Menu.Item>
        <Link to={routes.admin.delegationLogsSigning} rel="noopener noreferrer">
          {props.i18n.t("NamespaceAdminHeader:Delegation Log Signing List")}
        </Link>
      </Menu.Item>
    )}
  </SubMenu>
);

class PageLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: window.localStorage.getItem("menuCollapsed"),
    };
  }

  toggleCollapsed = () => {
    window.localStorage.setItem(
      "menuCollapsed",
      this.state.collapsed ? "" : "true"
    );
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  defaultSelectedKeys = () => {
    return [
      this.props.location.pathname === routes.admin.dashboard
        ? "dashboard"
        : "",
      this.props.location.pathname === routes.admin.reporting
        ? "reporting"
        : "",
    ];
  };

  render() {
    return (
      <div>
        <Layout className={classes.parentContainer}>
          {this.props.token && <AdminHeader />}
          <div className={classes.wrapper}>
            {this.props.token && !this.props.userInfoRoles.includes("Patient") && (
              <div
                style={{ width: this.state.collapsed ? 80 : 200 }}
                className={classes.sidebar}
              >
                <Button
                  type="primary"
                  onClick={this.toggleCollapsed}
                  style={{ margin: "0 0 10px 16px" }}
                  className={classes.toggleButton}
                >
                  <Icon
                    type={this.state.collapsed ? "menu-unfold" : "menu-fold"}
                  />
                </Button>
                {this.props.isProjectConfigurationActive && (
                  <Menu
                    defaultSelectedKeys={this.defaultSelectedKeys()}
                    mode="inline"
                    theme="dark"
                    inlineCollapsed={this.state.collapsed}
                    style={{ height: "calc(100% - 40px)" }}
                  >
                    <Menu.Item key="dashboard">
                      <Link to={routes.admin.dashboard}>
                        <Icon type="pie-chart" />
                        <span>{this.props.i18n.t("Dashboard")}</span>
                      </Link>
                    </Menu.Item>
                    {menuRandomization(this.props)}

                    {menuPatients(this.props)}

                    {this.props.documentReadPermission && (
                      <Menu.Item key="documentsEditor">
                        <Link to={routes.admin.documentsEditor}>
                          <Icon type="copy" />
                          <span>
                            {this.props.i18n.t(
                              "NamespaceAdminHeader:Document management"
                            )}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}

                    {this.props.viewDocumentDashboardPermission && (
                      <Menu.Item key="documentsDashboard">
                        <Link to={routes.admin.documentsDashboard}>
                          <Icon type="copy" />
                          <span>
                            {this.props.i18n.t(
                              "NamespaceAdminHeader:Document dashboard"
                            )}
                          </span>
                        </Link>
                      </Menu.Item>
                    )}
                    {this.props.isDrugManagementActive &&
                      menuDrugManagement(this.props)}

                    {(this.props.documentTrainingReadPermission ||
                      this.props.documentPublicReadPermission ||
                      this.props.documentStudyRegulatoryBinderPermission ||
                      this.props.documentPharmacyBinderPermission ||
                      this.props.documentGeneralReadPermission ||
                      this.props.documentGeneralPrivateReadPermission ||
                      this.props.documentValidationReadPermission ||
                      this.props.documentPerSiteReadPermission ||
                      this.props.documentPerSitePrivateReadPermission ||
                      this.props.auditLogReadPermission ||
                      this.props.simulationReadPermission ||
                      this.props.delegationLogAdminReadPermission ||
                      this.props.delegationLogSignPermission) &&
                      menuTrialResources(this.props)}

                    {menuFinance(this.props)}

                    {this.props.newsletterReadPermission && (
                      <Menu.Item key="newsletter">
                        <Link to="/admin/newsletter">
                          <Icon type="mail" />
                          <span>{this.props.i18n.t("Mailing List")}</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {this.props.reportsReadPermission && (
                      <Menu.Item key="reporting">
                        <Link to={routes.admin.reporting}>
                          <Icon type="file" />
                          <span>{this.props.i18n.t("Reporting")}</span>
                        </Link>
                      </Menu.Item>
                    )}
                  </Menu>
                )}
              </div>
            )}
            <div
              className={classNames(classes.content, {
                [classes.collapsed]: this.state.collapsed,
                [classes.full]:
                  !this.props.token ||
                  this.props.userInfoRoles.includes("Patient"),
              })}
            >
              {/*<h2 className={classes.headline}>{this.props.title}</h2>*/}
              {this.props.children}

              {this.props.token && this.props.isProjectConfigurationActive && (
                <Footer noAdminLink />
              )}
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: getUserToken(state),
  patientProfileReadPermission: getPatientProfileReadPermission(state),
  readUnassignedConsentRecordsPermission: getReadUnassignedConsentRecordsPermission(
    state
  ),
  patientProfileCreatePermission: getPatientProfileCreatePermission(state),
  SAEReadPermission: getSAEReadPermission(state),
  followUp7dReadPermission: getFollowUp7dReadPermission(state),
  followUp30dReadPermission: getFollowUp30dReadPermission(state),
  adminSettingsPermission: getAdminSettingsPermission(state),
  userInfo: getUserInfo(state),
  languages: getLanguages(state),
  simulationReadPermission: getSimulationReadPermission(state),
  siteReadPermission: getSiteReadPermission(state),
  roleReadPermission: getRoleReadPermission(state),
  userReadPermission: getUserReadPermission(state),
  subjectProfileUploadReadPermission: getSubjectProfileUploadReadPermission(
    state
  ),
  unblindingRequestCreatePermission: getUnblindingRequestCreatePermission(
    state
  ),
  unblindingRequestApprovePermission: getUnblindingRequestApprovePermission(
    state
  ),
  unblindingRequestReadPermission: getUnblindingRequestReadPermission(state),
  documentReadPermission: getDocumentReadPermission(state),
  documentTrainingReadPermission: getDocumentTrainingReadPermission(state),
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
  documentPerSiteReadPermission: getDocumentPerSiteReadPermission(state),
  documentPerSitePrivateReadPermission: getDocumentPerSitePrivateReadPermission(state),
  documentGeneralReadPermission: getDocumentGeneralReadPermission(state),
  documentGeneralPrivateReadPermission: getDocumentGeneralPrivateReadPermission(
    state
  ),
  documentValidationReadPermission: getDocumentValidationReadPermission(state),
  auditLogReadPermission: getAuditLogReadPermission(state),
  drugAccessPermissionInEnrollment: getDrugAccessPermissionInEnrollment(state),
  drugReadPermissions: getDrugReadPermission(state),
  reportsReadPermission: getReportsReadPermission(state),
  randomizationAccessPermission: getRandomizationAccessPermission(state),
  apiIbmReadPermission: getApiIbmReadPermission(state),
  apiEcoaReadPermission: getApiEcoaReadPermission(state),
  apiImednetReadPermission: getApiImednetReadPermission(state),
  apiDatafaxReadPermission: getApiDatafaxReadPermission(state),
  financeReadPermission: getFinanceReadPermission(state),
  financeCustomerReadPermission: getFinanceCustomerReadPermission(state),
  financeInvoiceReadPermission: getFinanceInvoiceReadPermission(state),
  consentAccessPermission: getConsentAccessPermission(state),
  financeEventReadPermission: getFinanceEventReadPermission(state),
  financeInvoiceGeneratedEventReadPermission: getFinanceInvoiceGeneratedEventReadPermission(
    state
  ),
  subjectIssuesReadPermission: getSubjectIssuesReadPermission(state),
  myProfileReadPermission: getMyProfileReadPermission(state),
  myProfileViewIdPermission: getMyProfileViewIdPermission(state),
  permissions: getPermissions(state),
  documentPharmacyBinderPermission: getDocumentPharmacyBinderPermission(state),
  documentStudyRegulatoryBinderPermission: getDocumentStudyRegulatoryBinderPermission(
    state
  ),
  validateRandomizationAccessPermission: getValidateRandomizationAccessPermission(
    state
  ),
  newsletterReadPermission: getNewsletterReadPermission(state),
  customFormsReadPermission: getCustomFormsReadPermission(state),
  theme: getTheme(state),
  isDrugManagementActive: getDrugManagementStatus(state),
  validationRequiredStatus: getValidationRequiredStatus(state),
  isProjectConfigurationActive: getProjectConfigurationStatus(state),
  delegationLogAdminReadPermission: getDelegationLogAdminReadPermission(state),
  delegationLogSignPermission: getDelegationLogSignPermission(state),
  userInfoRoles: getUserInfoRoles(state),
  viewDocumentDashboardPermission: getViewDocumentDashboardPermission(state),
  getReadRedcapApiConfigPermission: getReadRedcapApiConfigPermission(state),
  getReadDFDiscoverApiConfigPermission: getReadDFDiscoverApiConfigPermission(state),
});
export default connect(mapStateToProps)(
  withRouter(withNamespaces()(PageLayout))
);



// WEBPACK FOOTER //
// ./src/containers/PageLayout/PageLayout.js